import { useCallback } from 'react';

import pageRepository from '@/features/pages/repositories/PageRepository';

export function usePageListActions() {
  const getPages = useCallback(async () => {
    await pageRepository.cleanupOldArchivedPages();
    return pageRepository.getAllPages('updatedAt');
  }, []);

  return {
    getPages,
  };
}
